import { EventCategory } from '@orbit/api-types'

/** Every event / idea category, in the order the pickers list them. */
export const EVENT_CATEGORIES: EventCategory[] = [
	'FoodAndDrink',
	'SeeAndDo',
	'Nature',
	'Shopping',
	'Accommodation',
	'Transportation',
	'Event',
	'Other',
]

export const EVENT_CATEGORY_LABELS: Record<EventCategory, string> = {
	FoodAndDrink: 'Food & Drink',
	SeeAndDo: 'See & Do',
	Nature: 'Nature',
	Shopping: 'Shopping',
	Accommodation: 'Accommodation',
	Transportation: 'Transportation',
	Event: 'Events',
	Other: 'Other',
}

/** The categories as Dropdown options — the event form, the idea form and the event editor share it. */
export const EVENT_CATEGORY_OPTIONS = EVENT_CATEGORIES.map(category => ({
	value: category,
	label: EVENT_CATEGORY_LABELS[category],
}))
